import { useState, useEffect } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { translations } from './translations';

// Store Zustand persistant
const useLangStore = create(
  persist(
    (set) => ({
      language: 'fr',
      setLanguage: (lang) => set({ language: lang }),
    }),
    { name: 'paychat-lang' }
  )
);

// Hook principal
export const useLang = () => {
  const { language, setLanguage } = useLangStore();
  const t = (key) => translations[language]?.[key] || translations['fr'][key] || key;
  
  const setLang = (lang) => {
    setLanguage(lang);
    // Forcer re-render de tous les composants après 100ms
    setTimeout(() => {
      const event = new CustomEvent('paychat-lang-change', { detail: lang });
      window.dispatchEvent(event);
    }, 50);
  };

  return { t, language, setLang };
};

export default useLang;
